import React from "react";
import { HorizontalBar, Pagination, PaginationButton } from "./style";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { useState, useEffect } from 'react';
import "./index.css";
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import ReactLoading from "react-loading";
import APIConfig from "../../../api/APIConfig";

import {
    Box,
    Center,
    Text,
    Button,
    VStack,
} from '@chakra-ui/react';

function AdminPembayaran() {;
    const [listLowonganPeserta, setListLowonganPeserta] = useState([]);
    const [spinner, setSpinner] = useState(false);  

    const navigate = useNavigate();

    const getListLowonganPeserta = async() => {
        setSpinner(true);
        const response = await APIConfig.get("/v1/list-lowonganPeserta/");
        const data = await response.data
        setListLowonganPeserta(data);

        setSpinner(false);
    };

    const [selectedValue, setSelectedValue] = useState(0);
    const handleSearchKategori = (e) => {
        setSelectedValue(e.value);
    };

    const matcher = (data) => {
        console.log(selectedValue);
        if (selectedValue === 0) return true;
        else if (selectedValue === 1) {
            if (data.statusPembayaran === "Menunggu pembayaran") return true;
        } else if (selectedValue === 2) {
            if (data.statusPembayaran ==="Lunas") return true;
        } else if (selectedValue === 3) {
            if (data.statusPembayaran ==="Menunggu konfirmasi") return true;
        } else if (selectedValue === 4) {
            if (data.statusPembayaran ==="Ditolak") return true;
        } 
        return false;
    };


    useEffect(() => {
        getListLowonganPeserta();        
    }, []);

    const optionKategori = [
        { value: 0, label: "--- Pilih Status ---" },
        { value: 1, label: "Menunggu pembayaran" },
        { value: 2, label: "Lunas" },
        { value: 3, label: "Menunggu konfirmasi" },
        { value: 4, label: "Ditolak" },
    ]

    let data = listLowonganPeserta;
    const [currentPage, setCurrentPage] = useState(1);
    const pageNumbers = [];
    for (let i = 1; i <= Math.ceil(data.length / 10); i++) {
        pageNumbers.push(i);
    }

    const indexOfLastData = currentPage * 10;
    const indexOfFirstData = indexOfLastData - 10;
    data = data.slice(indexOfFirstData, indexOfLastData);
    
    data = data.filter((i) => matcher(i));

    if (spinner) {
        return (
            <Center py={12}>
                <VStack align='stretch' fontFamily={'Inter'} pb={20}>
                <div className="section">
                    <div className="article">
                        <ReactLoading type="spin" color="#6554C0" />
                    </div>
                </div>
                </VStack>
            </Center>
              
        )
    }

    return(
        <div className="container">
        <Center py={6}>
        <VStack align='stretch' fontFamily={'Inter'} pb={20}>
            <Text
                pt={10}
                pb={10}
                color={'gray.700'}
                fontWeight={600}
                fontSize={'2xl'}>
                Verifikasi Pembayaran
            </Text>
            <Box fontSize='xs' width='30%' pt={3} paddingBottom={3}>
            <Select
                borderRadius="50%"
                fontSize='13px'
                pt={3}
                paddingBottom={3}
                border='1px solid #F5F5F5'
                width='30%'
                height='40px' 
                id='kategori' 
                options={optionKategori}
                onChange={handleSearchKategori}
                value={optionKategori.find((obj) => obj.value === selectedValue)}
                placeholder=" --- Status --- " />
            </Box>
            <Box
                w='4xl'
                h="100%"
                border='1px'
                borderColor='gray.200'
                alignContent={'center'}
                rounded={'2xl'}
                p={2}
                overflow={'hidden'}>
                <VStack align='center'>
                {data.length > 0 ? 
                    <Table style={{width: '92.5%', margin: '20px 0'}}>
                        <Thead className="head">
                            <Tr>
                            <Th className='layout'><p className='layoutp'>Nama Pelamar</p></Th>
                            <Th className='layout'><p className='layoutp'>Email Pelamar</p></Th>
                            <Th className='layout'><p className='layoutp'>Aktivitas</p></Th>
                            <Th className='layout'><p className='layoutp'>Mitra Penyelenggara</p></Th>
                            <Th className='layout'><p className='layoutp'>Posisi Lamaran</p></Th>
                            <Th className='layout'><p className='layoutp'>Status Pembayaran</p></Th>
                            <Th className='layout'><p className='layoutp'>Detail</p></Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                        {data.map((data) => (
                            <Tr>
                                <Td className='layout'><p className='layoutp'>{data.peserta.namaPeserta}</p></Td>
                                <Td className='layout'><p className='layoutp'>{data.peserta.user.emailUser}</p></Td>
                                <Td className='layout'><p className='layoutp'>{data.lowongan.proposal.namaProposal}</p></Td>
                                <Td className='layout'><p className='layoutp'>{data.lowongan.mitra.namaResmi}</p></Td>
                                <Td className='layout'><p className='layoutp'>{data.lowongan.proposal.namaPosisi}</p></Td>
                                <Td className='layout'><p className='layoutp'>{data.statusPembayaran}</p></Td>
                                <Td>
                                    <Button 
                                        onClick={() => navigate(`/admin/detail/pembayaran/${data.idLowonganPeserta}`)}
                                        size='xs' rounded={'xl'} colorScheme='purple' variant='solid' fontSize={'xs'} margin={'0 10px'}>
                                        Lihat Pembayaran
                                    </Button>
                                </Td>
                            </Tr>
                        ))}
                        </Tbody>
                    </Table>
                    : 
                    <Text fontSize={"large"} fontWeight={'600'}>Tidak ada pembayaran</Text>
                    }
                    {data.length > 0 ? (<HorizontalBar last={true} />) : null}
                                {pageNumbers.length > 1 && (
                                    <Pagination
                                    style={{margin: 'auto'}}>
                                        <PaginationButton onClick={() => 
                                            setCurrentPage(1)}>
                                            &lt;&lt;
                                        </PaginationButton>
                                        <PaginationButton onClick={() => 
                                            currentPage === 1 ? setCurrentPage(1) : setCurrentPage(currentPage-1)}>
                                            &lt;
                                        </PaginationButton>
                                        {pageNumbers.map((page) => (
                                            <PaginationButton
                                                unshow={
                                                    currentPage > 2 && pageNumbers.length - currentPage > 1
                                                    ? Math.abs(currentPage - page) > 2
                                                    : pageNumbers.length - currentPage < 2
                                                    ? pageNumbers.length - page > 4
                                                    : page > 5
                                                }
                                                active={currentPage === page}
                                                onClick={() => setCurrentPage(page)}
                                                >
                                                    {page}
                                            </PaginationButton>
                                        ))}
                                        <PaginationButton
                                            onClick={() =>
                                            currentPage === pageNumbers.length
                                                ? setCurrentPage(pageNumbers.length)
                                                : setCurrentPage(currentPage + 1)
                                            }
                                        >
                                            &gt;
                                        </PaginationButton>
                                        <PaginationButton onClick={() => setCurrentPage(pageNumbers.length)}>
                                            &gt;&gt;
                                        </PaginationButton>
                                    </Pagination>
                                )}
                </VStack>
            </Box>
            </VStack>
            </Center>
        </div>
    );
}

export default AdminPembayaran;